import { carouselItems } from '@/mocks/homeData';

export default function CarouselSection() {
  return (
    <section id="carousel" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 text-center mb-2">
          焦点专题
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          深度策划的重磅专题报道，全方位解读热点事件
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 max-w-6xl mx-auto">
          {carouselItems.map((item, i) => (
            <article
              key={i}
              className={`group rounded-lg overflow-hidden bg-background-50 border border-background-200/70 hover:border-accent-200 transition-all duration-300 cursor-pointer ${
                i === 0 ? 'md:col-span-2 lg:col-span-2' : ''
              }`}
            >
              <div className="relative overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className={`w-full object-cover transition-transform duration-500 group-hover:scale-105 ${
                    i === 0 ? 'h-48 md:h-56' : 'h-40 md:h-44'
                  }`}
                  loading={i > 2 ? 'lazy' : undefined}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
                {item.tag && (
                  <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full text-[11px] font-medium bg-accent-500 text-background-50 whitespace-nowrap">
                    {item.tag}
                  </span>
                )}
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-base md:text-lg font-medium text-foreground-900 group-hover:text-accent-600 transition-colors duration-200 mb-2 line-clamp-2">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-3">
                  {item.desc}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}